import Api from '../api'

export default ({

  state: {
    warehouseGroupLists: [],
    warehouseLists: [],
    warehouseDropDownList: []
  },
  mutations: {
    ADD_WAREHOUSE_GROUP (state, warehouseGroupLists) {
      let warehouseGroupList = state.warehouseGroupLists.concat(warehouseGroupLists)
      state.warehouseGroupLists = warehouseGroupList
    },
    ADD_WAREHOUSE (state, warehouseLists) {
      let warehouseList = state.warehouseLists.concat(warehouseLists)
      state.warehouseLists = warehouseList
    },
    SET_WAREHOUSE_GROUP (state, warehouseGroupList) {
      state.warehouseGroupLists = warehouseGroupList
    },
    SET_WAREHOUSE (state, warehouseList) {
      state.warehouseLists = warehouseList
    },
    SET_WAREHOUSE_DROPDOWN(state, warehouseDropDownList) {
      state.warehouseDropDownList = warehouseDropDownList
    },
    DELETE_WAREHOUSE_GROUP (state, groupId) {
      let warehouseGroup = state.warehouseGroupLists.filter(a => a.id !== groupId.id)
      state.warehouseGroupLists = warehouseGroup
    },
    DELETE_WAREHOUSE (state, warehouseId) {
      let warehouse = state.warehouseLists.filter(a => a.id !== warehouseId.id)
      state.warehouseLists = warehouse
    },
    UPDATE_WAREHOUSE(state, updatedWarehouse) {
      state.warehouseLists = state.warehouseLists.map(warehouse => warehouse.id !== updatedWarehouse.id ? warehouse : {...warehouse, ...updatedWarehouse})
    },
    UPDATE_WAREHOUSE_GROUP(state, updatedWarehouseGroup) {
      state.warehouseGroupLists = state.warehouseGroupLists.map(warehouseGroup => warehouseGroup.id !== updatedWarehouseGroup.id ? warehouseGroup : {...warehouseGroup, ...updatedWarehouseGroup})
    }
  },
  actions: {
    async createWarehouseGroup({commit}, warehouseGroup) {
      let response = await Api.request('post', '/warehouse/warehouseGroup/' + this.state.organisationid + '/' + this.state.user.id, warehouseGroup)
      let savedWarehouseGroup = response.data.data
      commit('ADD_WAREHOUSE_GROUP', savedWarehouseGroup)
      return response
    },
    async createWarehouse({commit}, warehouse) {
      let response = await Api.request('post', '/warehouse/' + this.state.organisationid + '/' + this.state.user.id, warehouse)
      let savedwarehouse = response.data.data
      commit('ADD_WAREHOUSE', savedwarehouse)
      return response
    },
    async loadWarehouseGroupList({commit}) {
      let response = await Api.request('get', '/warehouse/warehouseGroupList/' + this.state.organisationid, null)
      commit('SET_WAREHOUSE_GROUP', response.data.data)
    },
    async loadWarehouseList({commit}) {
      let response = await Api.request('get', '/warehouse/' + this.state.organisationid, null)
      commit('SET_WAREHOUSE', response.data.data)
    },
    async deleteWarehouseGroup({commit}, warehouseGroup) {
      let response = await Api.request('delete', '/warehouse/warehouseGroup/' + warehouseGroup.id + '/' + this.state.user.id + '/' + warehouseGroup.deleteReason)
      let warehouseGroupLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_WAREHOUSE_GROUP', warehouseGroupLists)
      }
      return response
    },
    async deleteWarehouse({commit}, warehouse) {
      let response = await Api.request('delete', '/warehouse/' + warehouse.warehouseId + '/' + this.state.user.id + '/' + warehouse.deleteReason)
      let warehouseLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_WAREHOUSE', warehouseLists)
      }
      return response
    },
    async updateWarehouse({commit}, warehouse) {
      let response = await Api.request('put', '/warehouse/' + warehouse.id, warehouse)
      // if (response.data.status === 'SUCCESS') {
      commit('UPDATE_WAREHOUSE', response.data.data)
      // }
      return response
    },
    async updateWarehouseGroup({commit}, warehouseGroup) {
      let response = await Api.request('put', '/warehouse/warehouseGroup/' + warehouseGroup.id, warehouseGroup)
      commit('UPDATE_WAREHOUSE_GROUP', response.data.data)
      return response
    },
    async loadWarehouseDropDown({commit}) {
      let response = await Api.request('get', '/warehouse/warehouseDropDown/' + this.getters.organisationId)
      commit('SET_WAREHOUSE_DROPDOWN', response.data.data)
      return response
    }
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/warehouse.js